<template>
  <div class="game-box">
    <div v-if="timeList.length > 0">
      <div class="match-time-box">
        <span class="line-left">‹</span>
        <div
          v-for="(data, index) in timeList"
          :key="index"
          class="day-box"
          :style="{ marginLeft: index === 0 ? '60px' : '0' }"
          @click="switchTime(data)"
        >
          <div
            :class="
              valData.matchTime === matchFun.formatDate(data.matchTime, false)
                ? 'day-font-curr'
                : 'day-font'
            "
          >
            {{ data.matchTime.slice(5, 10) }}
          </div>
          <div
            :class="
              valData.matchTime === matchFun.formatDate(data.matchTime, false)
                ? 'day-curr'
                : 'day-nocurr'
            "
          ></div>
          <div
            class="chang-font"
            :style="{
              display:
                valData.matchTime === matchFun.formatDate(data.matchTime, false)
                  ? 'block'
                  : 'none',
            }"
          >
            {{ total }}场
          </div>
        </div>
        <span class="line-right">›</span>
      </div>
      <div class="match-address-box">
        <div
          v-for="(item, ind) in addressList"
          :key="ind"
          :class="
            valData.addressName === item.addressName
              ? 'address-right font-address-curr'
              : 'address-right font-address'
          "
          @click="switchAddress(item)"
        >
          {{ item.addressName }}
        </div>
      </div>
      <div class="match-show-box">
        <div
          @click="switchShow(0)"
          :class="valData.isEnd === 0 ? 'show-curr' : 'show-nocurr'"
        >
          全部显示
        </div>
        <div
          @click="switchShow(1)"
          :class="valData.isEnd === 1 ? 'show-curr' : 'show-nocurr'"
        >
          未开始
        </div>
        <div
          @click="switchShow(2)"
          :class="valData.isEnd === 2 ? 'show-curr' : 'show-nocurr'"
        >
          已结束
        </div>
      </div>
    </div>
    <div class="match-address-box" style="text-align: center; margin-top: 20px">
      <a-table
        :loading="loading"
        :pagination="false"
        :customRow="rowClick"
        :rowKey="(record) => record.fieldNum"
        :columns="columns"
        :rowClassName="rowClassName"
        :data-source="data"
      >
        <span slot="state" slot-scope="text">
          <a-tag v-if="text === '已结束'" color="#ccc">
            {{ text }}
          </a-tag>
          <a-tag v-if="text === '检录中'" color="#2db7f5">
            {{ text }}
          </a-tag>
          <a-tag v-if="text === '进行中'" color="#17bf39">
            {{ text }}
          </a-tag>
          <a-tag v-if="text === '未开始'">{{ text }}</a-tag>
        </span>
        <span slot="result" slot-scope="text, record">
          <ResultScoreTag v-if="!record.redName" :record="record"/>
          <ResultPkTag v-else :record="record"/>
        </span>
        <a slot="name" slot-scope="text">{{ text }}</a>
        <a slot="addressName" slot-scope="text">{{ text }}场地</a>
        <span slot="data" slot-scope="text, record">
          <div
            v-if="record.redName"
            style="
              color: rgb(180, 16, 0);
              width: 54%;
              float: left;
              text-align: right;
            "
          >
            {{ record.redName }}
            <span
              v-if="
                record.isTeam === 0 ||
                (record.isTeam === 1 &&
                  record.redPeopleList !== null &&
                  record.redPeopleList.length > 3)
              "
            >
              <a-avatar
                shape="square"
                v-if="record.redImg"
                :src="record.redImg"
                size="large"
                icon="user"
              />
            </span>
            <b style="color: red"
              >&ensp;<i style="color: rgb(180, 16, 0)">V</i
              ><i style="color: rgb(18, 146, 193)">S</i>&ensp;</b
            >
          </div>
          <div
            :style="{
              color: 'rgb(18, 146, 193)',
              width: record.redName ? '46%' : '76%',
              float: 'right',
              textAlign: 'left',
            }"
          >
            <span
              v-if="
                record.isTeam === 0 ||
                (record.isTeam === 1 &&
                  record.bluePeopleList !== null &&
                  record.bluePeopleList.length > 3)
              "
            >
              <a-avatar
                shape="square"
                v-if="record.blueImg"
                :src="record.blueImg"
                size="large"
                icon="user"
              />
            </span>
            {{ record.blueName }}
          </div>
        </span>
        <!-- <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <a-card style="width:50%;float:left;" v-if="record.redPeopleList" :title="programVictoryXs.getColor(record.programId).red + '方选手（单位名称：' + record.redTeamName + ')'">
            <a-card-grid v-for="(item, index) in record.redPeopleList" :key="index" style="width:20%;text-align:center">
              <a-avatar shape="square" v-if="item.img" :src="item.img" size="large" icon="user" /><br/>
              {{ item.name }}
            </a-card-grid>
          </a-card>
          <a-card :style="{width: record.redPeopleList ? '49%' : '100%', float:'right'}" v-if="record.bluePeopleList" :title="programVictoryXs.getColor(record.programId).blue + '方选手（单位名称：' + record.blueTeamName + ')'">
            <a-card-grid v-for="(item, index) in record.bluePeopleList" :key="index" style="width:20%;text-align:center">
              <a-avatar shape="square" v-if="item.img" :src="item.img" size="large" icon="user" /><br/>
              {{ item.name }}
            </a-card-grid>
          </a-card>
        </p> -->
      </a-table>
      <div v-if="isMore">
        <a-button @click="onLoadMore" style="margin: 20px"> 加载更多 </a-button>
      </div>
    </div>
    <!-- 场次对战弹窗 -->
    <div class="game-modal">
      <div ref="yourModal"></div>
      <a-modal class="modal" v-model="showModal" @ok="handleOk"   :footer="null"  :maskClosable="false" :getContainer="() => $refs.yourModal" :destroyOnClose="true">  
        <template v-slot:closeIcon>
          <div class="close-icon">
           <img src="../../assets/cha.svg" alt="">
          </div>
        </template>
        <DefaultGameModal :currentMatch="currentMatch" />
      </a-modal>
    </div>
  </div>
</template>
<script>
import programVictoryXs from '@comm/utils/programVictoryXs'
import matchFun from '@comm/utils/matchFun'
import ResultScoreTag from './ResultScoreTag'
import ResultPkTag from './ResultPkTag'
import DefaultGameModal from './DefaultGameModal'
export default {
  name: 'DefaultGame',
  components: {
    ResultScoreTag,
    ResultPkTag,
    DefaultGameModal,
  },
  created () {
    this.findAddress()
  },
  watch: {
    $route: 'findAddress',
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      //点击行
      rowClick: (record) => ({
        on: {
          click: () => {
            this.handleRowChange(record) //触发methods中的方法
          },
        },
      }),
      currentMatch:{},
      showModal:false,//显示分数弹窗
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      isMore: false,
      timeList: [],
      addressList: [],
      valData: {
        matchTime: '',
        addressName: '',
        matchId: this.$route.query.matchId,
        pageNum: 1,
        pageSize: 10,
        isEnd: 0,
      },
      matchFun: matchFun,
      programVictoryXs: programVictoryXs,
      columns: [
        {
          dataIndex: 'state',
          title: this.$t('状态'),
          width: '5%',
          align: 'center',
          scopedSlots: { customRender: 'state' },
        },
        {
          title: this.$t('场地'),
          width: '8%',
          align: 'center',
          dataIndex: 'addressName',
          scopedSlots: { customRender: 'addressName' },
        },
        {
          title: this.$t('进程'),
          align: 'center',
          width: '10%',
          dataIndex: 'rankStr',
        },
        {
          title: this.$t('场次号'),
          align: 'center',
          width: '8%',
          dataIndex: 'fieldNum',
        },
        {
          title: this.$t('项目'),
          align: 'center',
          width: '20%',
          dataIndex: 'combatName',
        },
        {
          title: this.$t('参赛信息'),
          align: 'center',
          width: '25%',
          dataIndex: 'data',
          scopedSlots: { customRender: 'data' },
        },
        {
          title: this.$t('结果'),
          align: 'center',
          width: '20%',
          dataIndex: 'result',
          scopedSlots: { customRender: 'result' },
        },
      ],
      loading: false,
      data: [],
      total: 0,
    }
  },
  methods: {
    //行背景颜色
    rowClassName (record,index) {
      if(index%2==0){
        let a123 = 'row-bg'
        return a123
      }
      
    },
    findAddress () {
      this.$api.battle
        .address({ matchId: this.matchId })
        .then((res) => {
          if (res.status === 0) {
            this.timeList = res.data
            if (this.timeList.length > 0) {
              this.valData.matchTime = this.matchFun.formatDate(
                this.timeList[0].matchTime,
                false
              )
              this.addressList = this.timeList[0].addressName
              this.valData.addressName =
                this.timeList[0].addressName[0].addressName
              this.findData(false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    findData (bool) {
      this.loading = true
      this.$api.battle
        .list(this.valData)
        .then((res) => {
          this.loading = false
          if (res.status === 0) {
            if (bool) {
              this.data = this.data.concat(res.data)
            } else {
              this.data = res.data
            }
            this.total = res.total
            this.isMore = this.total > this.data.length
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    switchTime (data) {
      this.valData.pageNum = 1
      this.valData.matchTime = this.matchFun.formatDate(data.matchTime, false)
      this.addressList = data.addressName
      this.valData.addressName = data.addressName[0].addressName
      this.findData(false)
    },
    switchAddress (data) {
      this.valData.pageNum = 1
      this.valData.addressName = data.addressName
      this.findData(false)
    },
    switchShow (isEnd) {
      this.valData.pageNum = 1
      this.valData.isEnd = isEnd
      this.findData(false)
    },
    onLoadMore () {
      this.valData.pageNum = this.valData.pageNum + 1
      this.findData(true)
    },
    expandIcon (props) {
      if (
        props.record.bluePeopleList !== null &&
        props.record.bluePeopleList.length > 0
      ) {
        if (props.expanded) {
          return (
            <a
              style="color: 'black',margin-right:0px"
              onClick={(e) => {
                props.onExpand(props.record, e)
              }}
            >
              <a-icon type="caret-down" />
            </a>
          )
        } else {
          return (
            <a
              style="color: 'black' ,margin-right:0px"
              onClick={(e) => {
                props.onExpand(props.record, e)
              }}
            >
              <a-icon type="caret-right" />
            </a>
          )
        }
      } else {
        return <span style="margin-right:0px"></span>
      }
    },
    //对战详情
    handleRowChange (currentMatch) {
      if((currentMatch.programId==47||currentMatch.programId==1||currentMatch.programId==20||currentMatch.programId==12||currentMatch.programId==2)&&currentMatch.victoryType){
        this.showModal=true
        this.currentMatch=currentMatch
      }else{
        // console.log('暂未更新')
      }
    
    },
    handleOk () {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .row-bg{
    background-color: #efefef;
}
  // 对战弹窗
 /deep/ .ant-modal {
  width: 1200px !important;
}
 /deep/ .ant-modal-content {
  border-radius: 20px !important;
}
  .close-icon{
    border-radius: 20px;
    position: absolute;
    height: 30px;
    width: 30px;
    line-height: 30px;
    text-align: center;
    top:-15px;
    margin-left: 60px;
    box-sizing: border-box;
    background-color: #ffffff;
    img{
      margin-top: -4px;
    }
  }
  //-----------
.match-show-box {
  width: 1200px;
  margin: 0 auto;
  height: 30px;
}
.show-curr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #434343;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.show-nocurr {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #ccc;
  color: white;
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.game-box {
  min-height: 300px;
}
.font-address-curr {
  font-weight: bold;
  font-size: 25px;
  background: #b80000;
  color: #fff;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.address-right {
  float: left;
  margin-right: 22px;
  cursor: pointer;
  margin-bottom: 20px;
}
.font-address {
  font-weight: bold;
  font-size: 25px;
  background: #eeeeee;
  color: #999999;
  min-width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border-radius: 5px;
}
.match-address-box {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.day-box {
  width: 100px;
  height: 100px;
  float: left;
  cursor: pointer;
}
.match-time-box {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  margin-top: 20px;
  position: relative;
  background-image: url(../../assets/dayline.png);
  background-size: 94% 2%;
  background-repeat: no-repeat;
  background-position-y: 39px;
  background-position-x: 36px;
}
.line-left {
  cursor: pointer;
  position: absolute;
  top: 24px;
  left: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  text-align: center;
  line-height: 21px;
  border: 1px solid #a0a0a0;
}
.line-right {
  position: absolute;
  top: 24px;
  right: 0px;
  font-size: 30px;
  color: #a0a0a0;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 21px;
  border-radius: 100%;
  cursor: pointer;
  border: 1px solid #a0a0a0;
}
.day-font {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #999999;
  text-align: center;
}
.day-font-curr {
  width: 100%;
  height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #b41000;
  text-align: center;
}
.day-curr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #b41000;
  margin-left: 37px;
  background: white;
}
.day-nocurr {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid #ccc;
  margin-left: 37px;
  background: white;
}
.chang-font {
  width: 60%;
  height: 25px;
  background: #b41000;
  color: white;
  border-radius: 5px;
  margin-left: 20px;
  margin-top: 7px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/modal/DefaultGame.vue